import React, { useState, useEffect} from "react";
import { Redirect } from 'react-router-dom'
import {
    TableRow,
} from '@material-ui/core';
import 'moment/min/locales';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles.js';
import Loading from '../ui/Loading.js';
import { useIntl } from "react-intl";
import swal from 'sweetalert'
import * as Utils from '../../commons/utils/Utils'
import { getDuracionesOptions } from '../../commons/utils/PeriodoPresupuesto';

const ConfigPeriodosPresupuestariosGridRow = ({config, loading, baseUrl}) => {
  const intl = useIntl()
  const [estaEnCurso, setEstaEnCurso] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  const duraciones = getDuracionesOptions(intl);
  const duracion = duraciones.find(d => d.value === config.duracion);
  const handleDelete = () => {
    
            if (estaEnCurso === true) {
                swal("No se puede eliminar", "El periodo ya está en curso y no puede ser eliminado.", "warning");
                return;
            } else {
              swal({
                title: '¿Confirma la eliminación?' ,
                text: null,
                icon: "warning",
                buttons: {
                    confirm: {
                        text: 'Si' ,
                        value: true,
                        visible: true,
                        className: "btn btn-primary",
                        closeModal: false
                    },
                    cancel: {
                        text:  'No' ,
                        value: null,
                        visible: true,
                        className: "btn btn-danger",
                        closeModal: true,
                    }
                }
            })
            .then((isConfirm) => {
                if (isConfirm) {
                      Utils.deleteData('/periodo-configs/' + config.id)
                      .then((response) => {
                        if (response) {
                          swal("Eliminado", "La configuración ha sido eliminada con éxito.", "success").then(() => {
                            window.location.reload();
                          });
                        } else {
                          swal("Error", "No se pudo eliminar la configuración.", "error");
                        }
                      })
                      .catch(() => {
                        swal("Error", "Ocurrió un error al intentar eliminar la configuración.", "error");
                      });
                }
            });
            }
  };

  const handleEditar = () => {
    if (estaEnCurso) {
        swal("No se puede editar", "El periodo ya está en curso y no puede ser editado.", "warning");
        return;
    } else {
        setRedirectTo(baseUrl + '/' + config.id + '/edit');
    }
  }

useEffect(() => {
  Utils.getData('/periodo-configs/validarInicio/' + config.id)
  .then((response) => {
      setEstaEnCurso(response);
  })
  .catch(() => {
      swal("Error", "Ocurrió un error al validar el estado del periodo.", "error");
  });
}, [config.id]);

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      {loading && <Loading />}
      <TableRow>
          <StyledTableCell align="left">
          {config.nombre}
          </StyledTableCell>
          <StyledTableCell align="left">
          {config.frecuencia.charAt(0).toUpperCase() + config.frecuencia.slice(1)}
          </StyledTableCell>
          <StyledTableCell align="left">
          {duracion ? duracion.label : ''}
          </StyledTableCell>
          <StyledTableCell align="left">
          {config.fecha_inicio}
          </StyledTableCell>
          <StyledTableCell>
          <div className="d-inline-flex">
              <button
                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                title="Ver"
                data-togle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + config.id)}
              >
                <i className="fa fa-search fa-xs"/>
              </button>
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                title="Editar"
                data-togle="tooltip"
                data-placement="top"
                onClick={handleEditar}
                >
                  <i className="fa fa-pencil fa-xs"/>
              </button>
              <button
                className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                title="Eliminar"
                data-togle="tooltip"
                data-placement="top"
                onClick={handleDelete}
                >
                  <i className="fa fa-trash fa-xs"/>
              </button>
          </div>
        </StyledTableCell>
      </TableRow>
      </>
  )
}


export default ConfigPeriodosPresupuestariosGridRow;